//像这种没有路径和文件夹名字的模块，从哪里查找？
//从node_modules文件夹中查找'js-cookie'的文件夹，然后文件夹中查找package.json文件，
//然后从json文件中查找'main'属性值:'src/js.cookie.js'
//import Cookies from 'js-cookie';  

const app = {
    state: {
      sidebar: {
        //opened: !+Cookies.get('sidebarStatus')
      },
      theme: 'default',
      //livenewsChannels: Cookies.get('livenewsChannels') || '[]',
      visitedViews: []
    },
    mutations: {// sync  .commit(ADD_VISITED_VIEWS,view) 
      TOGGLE_SIDEBAR: state => {
        // if (state.sidebar.opened) {
        //   Cookies.set('sidebarStatus', 1);
        // } else {
        //   Cookies.set('sidebarStatus', 0);
        // }
        state.sidebar.opened = !state.sidebar.opened;
      },
      ADD_VISITED_VIEWS: (state, view) => {
        // if (state.visitedViews.includes(view)) return
        // state.visitedViews.push(view)
        if (state.visitedViews.includes(view)) {
          //-6 要和tabsview.vue里的-6对应上（界面只显示6个标签）
          // if(!state.visitedViews.slice(-6).includes(view) )
          // {
          //   let arr = state.visitedViews;
          //   var index=arr.indexOf(view);
          //   arr.splice(index,1);
          //   arr.push(view);
          // }
          return
        }
        state.visitedViews.push(view)
      },
      DEL_VISITED_VIEWS: (state, view) => {
        const index = state.visitedViews.indexOf(view)
        state.visitedViews.splice(index, 1)
      },
      REMOVE_ALL_VIEWS:(state,view)=>{
        state.visitedViews=[];
      },
      REMOVE_OTHER_VIEWS:(state,view)=>{
        // state.visitedViews=[];
        // state.visitedViews.push(view);
        state.visitedViews=view;
      },
    },
    actions: {// async  dispatch('delVisitedViews',view)
      ToggleSideBar: ({ commit }) => {
        commit('TOGGLE_SIDEBAR')
      },
      addVisitedViews: ({ commit }, view) => {
        commit('ADD_VISITED_VIEWS', view)
      },
      delVisitedViews: ({ commit }, view) => {
        commit('DEL_VISITED_VIEWS', view)
      },
      clearAllViews({ commit },view) {
              commit("REMOVE_ALL_VIEWS",view);
          },
      clearOtherViews({ commit },view) {
              commit("REMOVE_OTHER_VIEWS",view);
          },
    }
  };
  
  export default app;
  


// WEBPACK FOOTER //
// ./src/store/modules/app.js